export interface AppValues {
  notFound: boolean
}

const createSlice = () => ({
  notFound: false,
})

export default createSlice
